module.exports = __webpack_public_path__ + "static/media/BannerIcon.4f1b1269.svg";